<template>
  <!-- 继续率系数 -->
  <div>
    <Modal v-model="visible" width="1200px" title="继续率系数" :footer-hide="true" :mask-closable="false" class="my-modal">
      <div class="tools-box">
        <Button type="primary" @click="addRow(list)" v-if="list.length == 0">新增</Button>
      </div>
      <div class="table" v-if="list.length">
        <div class="tr head">
          <div class="td th first-td">继续率指标</div>
          <div class="td th td2">继续率</div>
          <div class="table-box" v-for="head in topItem.commissionItems" :key="head.id">
            <div class="tr">
              <div class="td th">{{ head.productName }}</div>
            </div>
            <div class="tr">
              <div class="td th" v-for="head2 in head.programBaseList" :key="head2.id">{{ head2.name }}</div>
            </div>
          </div>
        </div>
        <div class="tr" v-for="(row, i) in list" :key="row.key" :id="'key' + row.key">
          <div class="td first-td">
            <Select v-model="row.indexValue" style="width: 120px" transfer :class="{ 'red-bor': row.error }">
              <Option value="1" label="R13"></Option>
              <Option value="2" label="R25"></Option>
              <Option value="3" label="R37"></Option>
              <Option value="4" label="R49"></Option>
            </Select>
            <Icon type="md-add-circle" color="#236DFF" size="24" @click="addRow(list)" />
            <Icon type="md-close-circle" color="#F26868" size="24" @click="del(list, i)" />
          </div>
          <div class="table-box">
            <div class="tr" v-for="row2 in row.coefficientItemList" :key="row2.key" :id="'key' + row2.key">
              <div class="td td2">
                <Input v-model="row2.ratioStart" placeholder="请输入" style="width: 90px" class="table-input" :class="{ 'red-bor': row2.startError }">
                  <span slot="append">%</span>
                </Input>
                <Select v-model="row2.ratioStartSymbol" style="width: 60px" transfer>
                  <Option value="1" label="<"></Option>
                  <Option value="2" label="≤"></Option>
                </Select>
                <span>R</span>
                <Select v-model="row2.ratioEndSymbol" style="width: 60px" transfer>
                  <Option value="1" label="<"></Option>
                  <Option value="2" label="≤"></Option>
                </Select>
                <Input v-model="row2.ratioEnd" placeholder="请输入" style="width: 90px" class="table-input" :class="{ 'red-bor': row2.endError }">
                  <span slot="append">%</span>
                </Input>
                <Icon type="md-add-circle" color="#236DFF" size="24" @click="addCommission(row.coefficientItemList, row.key)" />
                <Icon type="md-close-circle" color="#F26868" size="24" v-if="row.coefficientItemList.length != 1" @click="del(row.coefficientItemList, ii)" />
              </div>
              <div class="table-box" v-for="row3 in row2.coefficientValueGradeList" :key="row3.key">
                <div class="tr">
                  <div class="td" v-for="row4 in row3.coefficientValueItemList" :key="row4.key">
                    <Input
                      v-model="row4.coefficient"
                      placeholder="请输入"
                      class="table-input"
                      :class="{ 'red-bor': row4.commissionError }"
                      @input="inputChange(row4, $event, 'coefficient')"
                    >
                      <span slot="append">%</span>
                    </Input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ivu-modal-footer">
        <Button type="text" @click="cancel">取消</Button>
        <Button type="primary" @click="submit" :loading="loading">确定</Button>
      </div>
    </Modal>
    <!-- 确认弹窗 -->
    <confirm-modal ref="confirmModal"></confirm-modal>
  </div>
</template>
  
<script>
import confirmModal from '@/components/commons/confirmModal';
import renewalRateConfig from './renewalRateConfig.config.js';
import common from './common.config.js';
export default {
  mixins: [renewalRateConfig, common],
  components: { confirmModal },
  props: {
    curSupplier: null
  },
  data() {
    return {
      visible: false,
      loading: false,
      over: true,
      tableItem: {},
      agreementList: [], //协议列表
      topItem: {}
    };
  },
  computed: {},
  created() {},
  methods: {
    async open(e) {
      this.tableItem = e.tableItem;
      this.topItem = e.topItem;
      if (this.topItem.sourceType != 2) {
        return;
      }
      const status = await this.getStatusAll();
      if (status) {
        this.initData(true);
      } else {
        this.openBaseModal();
      }
    },
    // 新增行
    addRow() {
      const key = Date.now();
      const arr = this.topItem.commissionItems.map((item, i) => {
        const data = {
          key: 'c' + i,
          gradeCode: item.gradeCode,
          coefficientValueItemList: item.programBaseList.map((item2, ii) => ({
            key: 'd' + ii,
            programId: item2.id,
            coefficient: ''
          }))
        };
        return data;
      });
      this.list.push({
        key: 'a' + key,
        indexValue: '',
        coefficientItemList: [
          {
            key: 'b' + key,
            ratioStart: '',
            ratioStartSymbol: '1',
            ratioEndSymbol: '1',
            ratioEnd: '',
            coefficientValueGradeList: arr
          }
        ]
      });
      this.$nextTick(() => {
        document.getElementById('keya' + key).scrollIntoView();
      });
    },
    // 新增费用行
    addCommission(list, jumpKey) {
      const key = Date.now();
      const arr = this.topItem.commissionItems.map((item, i) => {
        const data = {
          key: 'c' + i,
          gradeCode: item.gradeCode,
          coefficientValueItemList: item.programBaseList.map((item2, ii) => ({
            key: 'd' + ii,
            programId: item2.id,
            coefficient: ''
          }))
        };
        return data;
      });
      list.push({
        key: 'b' + key,
        ratioStart: '',
        ratioStartSymbol: '1',
        ratioEndSymbol: '1',
        ratioEnd: '',
        coefficientValueGradeList: arr
      });
      this.$nextTick(() => {
        document.getElementById('keyb' + key).scrollIntoView({block: "end", inline: "nearest"});
        document.getElementById('key' + jumpKey).scrollIntoView({block: "nearest",inline: "start"});
      });
    },
    del(list, i) {
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: '请确认是否删除？'
        })
        .then(() => {
          list.splice(i, 1);
        });
    },
    cancel() {
      this.visible = false;
    },
    submit() {
      let hasErr = false;
      this.list.forEach((item, i) => {
        if (!item.indexValue) {
          this.$set(item, 'error', true);
          hasErr = true;
        } else {
          this.$set(item, 'error', false);
        }
        item.coefficientItemList.forEach(item2 => {
          if (!item2.ratioStart) {
            this.$set(item2, 'startError', true);
            hasErr = true;
          } else {
            this.$set(item2, 'startError', false);
          }
          if (!item2.ratioEnd) {
            this.$set(item2, 'endError', true);
            hasErr = true;
          } else {
            this.$set(item2, 'endError', false);
          }
          if (item2.ratioStart && item2.ratioEnd) {
            if (item2.ratioStart * 1 > item2.ratioEnd * 1) {
              this.$set(item2, 'startError', true);
              this.$set(item2, 'endError', true);
              hasErr = true;
            } else {
              this.$set(item2, 'startError', false);
              this.$set(item2, 'endError', false);
            }
          }
          item2.coefficientValueItemList = [];
          item2.coefficientValueGradeList.forEach(item3 => {
            item3.coefficientValueItemList.forEach(item4 => {
              item4.gradeCode = item3.gradeCode;
              if (item4.coefficient === '') {
                hasErr = true;
                this.$set(item4, 'commissionError', true);
              } else {
                this.$set(item4, 'commissionError', false);
              }
              item2.coefficientValueItemList.push(item4);
            });
          });
        });
      });
      if (hasErr) {
        return;
      }
      const params = {
        productCode: this.topItem.productCode,
        rateItemList: this.list
      };
      console.log(params);
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$http({
        url: '/buz/upcommission/configRetentionRate',
        type: 'POST',
        data: params
      })
        .then(res => {
          this.$notice.msg('操作成功');
          this.$emit('reload');
          this.visible = false;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './itemCommon.scss';
.tools-box {
  margin-top: 15px;
}
.table {
  margin-top: 30px;
  margin-bottom: 10px;
  max-width: 1140px;
  overflow-x: auto;
  .tr {
    .td {
      flex: 160px;
      min-width: 160px;
    }
    .first-td {
      flex: 200px;
      min-width: 200px;
    }
    .td2 {
      flex: 410px;
      min-width: 410px;
    }
  }
}
</style>  